import { FiCheck, FiStar, FiCircle } from 'react-icons/fi'
import { FaCrown } from 'react-icons/fa'
import {
  ANNUAL_MARKETING_TAGLINE,
  formatPlanCurrency,
  getAnnualTotal,
  getMonthlyAmount,
} from '../utils/subscriptionPlan'

export const CHECKOUT_PLANS = [
  {
    id: 'basico',
    name: 'Básico',
    icon: FiStar,
    badge: null,
    highlight: false,
    features: [
      'Até 2 dispositivos',
      '90 dias de histórico',
      '1 usuário convidado',
      'Alertas de nível e vazamento/pico',
      'Relatório semanal por e-mail',
    ],
  },
  {
    id: 'pro',
    name: 'Pro',
    icon: FaCrown,
    badge: 'RECOMENDADO',
    highlight: true,
    features: [
      'Todos os recursos do Básico',
      'Até 5 dispositivos',
      '365 dias de histórico',
      'Até 5 usuários convidados',
      'Controle remoto e exportação de dados',
    ],
  },
]

/** Planos exibidos na landing (inclui gratuito). */
export const PRICING_PLANS = [
  {
    id: 'gratuito',
    name: 'Gratuito',
    icon: FiCircle,
    badge: null,
    price: 'R$ 0',
    period: '/mês',
    highlight: false,
    features: [
      { text: '1 Dispositivo', included: true },
      { text: '30 dias de histórico', included: true },
      { text: 'Alertas de nível', included: true },
      { text: 'Alerta de vazamento/pico (30 dias trial)', included: true, trial: true },
      { text: 'Relatório semanal (e-mail)', included: false },
      { text: 'Usuários convidados', included: false },
      { text: 'Controle remoto', included: false },
      { text: 'Análise de pico', included: false },
      { text: 'Exportação de dados', included: false },
    ],
  },
  ...CHECKOUT_PLANS.map((plan) => ({
    ...plan,
    price: formatPlanCurrency(getMonthlyAmount(plan.id)),
    period: '/mês',
    annualHint: ANNUAL_MARKETING_TAGLINE,
    annualPrice: formatPlanCurrency(getAnnualTotal(plan.id)),
    features: plan.features.map((text) => ({ text, included: true })),
  })),
]

export function getCheckoutPlan(planId) {
  return CHECKOUT_PLANS.find((p) => p.id === planId) || null
}
